import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Pagination,Row,Col, Container, Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {viewFlatFile} from '../../Utilities/WSUtil';
import {FILE_NAME,CUSTOMIZED_REPORT} from '../../resources/constant';

import {SubmitBtn,MidCifBtn} from '../../theme/MorsTheme';

import {ContentDiv, BodyHeaderDiv, BodyHeaderText} from '../../theme/MorsTheme';

const propTypes = {
    items: PropTypes.array.isRequired,
    onChangePage: PropTypes.func.isRequired,
    initialPage: PropTypes.number,
    pageSize: PropTypes.number
}

const defaultProps = {
    initialPage: 1,    
    pageSize: 20
}

class ReportFileList extends Component{            
    constructor(props){
        super(props);                  
        this.state = {
            pager: {},
            pageOfItems: []
        };  
        this.viewReport = this.viewReport.bind(this);
        this.onChangePage = this.onChangePage.bind(this);   
        this.sortReport = this.sortReport.bind(this); 
        //this.setFileName = this.setFileName.bind(this);
    }
/*
    viewReport(fileName, path){        
        localStorage.removeItem(FILE_NAME);
        await viewFlatFile(path).then(response => {
            var fileResponse = [{fileName}, {response}];
            this.props.setFileName(fileName);
            localStorage.setItem(FILE_NAME, JSON.stringify(fileResponse));
        })
    }
*/


    async viewReport(fileName, path, mbId, folderName, reportType){     
        //await viewFlatFile(path).then(response => {
        await viewFlatFile(reportType, mbId, folderName, fileName).then(response => {
            var fileResponse = [{fileName}, {response}];
            this.props.setFileName(fileName);
            localStorage.setItem(FILE_NAME, fileName);
            localStorage.setItem(fileName, JSON.stringify(fileResponse));
        })

        //e.target = "_blank";
        //this.props.history.push("/viewReportFile");
       
        window.open('/mors/#/viewReportFile','_blank', 'rel=noopener noreferrer')
    }

    goBack = e => {
        e.preventDefault();

        this.props.history.goBack();
    }
    onChangePage(pageOfItems){        
        this.setState({pageOfItems: pageOfItems});
    }

    componentWillMount(){        

        if(this.props.items && this.props.items.length){            
            this.setPage(this.props.initialPage);
        }
    }
    componentDidUpdate(prevProps, prevState){     
        if(this.props.items !== prevProps.items){         
            this.setPage(this.props.initialPage);
        }
    }
    
    //Monina start - added
    compareMultiples(objs){
        return function(a, b) {
        var comparison = 0;
        objs.forEach(function(arg, i){
            var tempResult = a[arg.field].localeCompare(b[arg.field]);
            comparison = comparison || ((arg.order === 'desc') ? (tempResult * -1) : tempResult);
        });
        
        return comparison;
        }
    }
    //Monina end - added

    setPage(page){
        var {items, pageSize} = this.props;
        //Monina start - added
        items.sort(this.compareMultiples([{field:'folderName',order:'desc'},{field:'mbId',order:'asc'}]));
        //Monina end - added
        var pager = this.state.pager;
        if(page<1 || page > pager.totalPages){
            return;
        }        
        pager = this.getPager(items.length, page, pageSize);
        var pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);
        this.setState({pager: pager});        
        this.onChangePage(pageOfItems);        
    }

    getPager(totalItems, currentPage, pageSize){                               
        currentPage = currentPage || 1;
        pageSize = pageSize || 20;        
        var totalPages = Math.ceil(totalItems/pageSize);        
        var startPage, endPage;        
        if(totalPages <=10){
            startPage = 1;
            endPage = totalPages;
        }
        
        else{
            if(currentPage <=4){
                startPage = 1;
                endPage = 20;
            }else if(currentPage + 4 >= totalPages){
                startPage = totalPages - 4;
                endPage = totalPages;
            }else{
                startPage = currentPage - 20;
                endPage = currentPage + 4;                
            }
        }

        var startIndex = (currentPage - 1 ) * pageSize;
        var endIndex = Math.min(startIndex + pageSize -1, totalItems -1);
        var pages = [...Array((endPage +1) - startPage).keys()].map(i=> startPage +i);

        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages:pages
        };    
    }

    sortReport(){
        alert("test");
        var data = this.props.items;
        data.sort((a, b) =>  b.mbId - a.mbId);
        
        
        
    }
                     
    render(){ 

        var pager = this.state.pager;
        return(
            <div>                            
                <BodyHeaderDiv>
                    <BodyHeaderText>List of Reports</BodyHeaderText>
                </BodyHeaderDiv>
                <ContentDiv>        
                <Container fluid={true}>            
                    <Row as={Row} noGutters md={12} xs={12} style={this.props.items.length !== 0 ? {display:'block'}: {display:'none'}}>    
                        <Row noGutters>
                            <Col xs={2} md={2}>Date</Col>
                            <Col xs={2} md={2}>{this.props.typeReport===CUSTOMIZED_REPORT?'DBA name':'MID'}</Col>
                            <Col xs={8} md={8}>Filename</Col>
                        </Row>
                        {this.state.pageOfItems.map((item, index) =>                                                             
                            <Row style={{wordBreak: 'break-all',fontSize:'12px'}} key={index} md={12} xs={12}>   
                                <Col xs={2} md={2}><span style={{fontSize:'12px'}}>{item.folderName}</span></Col>
                                <Col xs={2} md={2}><span style={{fontSize:'12px'}}>{item.mbId}</span></Col>
                                <Col xs={8} md={8} style={{wordBreak: 'break-all'}}>          
                                {/*Monina added - style={{wordBreak: 'break-all'}} */}                      
                                  {/*
                                  <Link 
                                    onMouseDown={() =>this.viewReport(item.fileName, item.absolutePath)}
                                    to="/viewReportFile" target="_blank"> <span style={{fontSize:'12px'}}>{item.fileName}</span></Link>                                                                   
                                  */}
                                    <Button variant="text" style={{padding: '0px'}}
                                    onClick={() => this.viewReport(item.fileName, item.absolutePath, item.mbId, item.folderName, item.reportType)}
                                    > <span style={{fontSize:'12px', color: '#007BFF'}}>{item.fileName}</span>
                                    </Button>                                                                   
                                    
                                </Col>
                            </Row>
                            )}                                            
                        
                    </Row>
                    {/* <MidCifBtn onClick={this.sortReport}>...</MidCifBtn>       */}
                    <div align="center" style={this.props.items.length !== 0 ? {display:'block', marginTop: '20px'}: {display:'none'}}>                            
                        <Pagination style={{display: 'flex', justifyContent:'center'}}>
                            <Pagination.First onClick={() => this.setPage(1)} />                                                                        
                            <Pagination.Prev onClick={() => this.setPage(pager.currentPage - 1)}/>                                                                        
                            <Pagination.Next onClick={() => this.setPage(pager.currentPage + 1)}/>
                            <Pagination.Last onClick ={() => this.setPage(pager.totalPages)}/>                     
                        </Pagination>                                             
                        
                        <div align="center">
                            <span>Page {pager.currentPage}</span> / {" "}                            
                            <span>{pager.totalPages}</span>
                        </div>  
                    </div>
                    
                                
                    <Row>
                        <Col>
                        <div style={this.props.items.length === 0 ? {display:'block'}: {display:'none'}}>
                            <span style={{color:'red'}}>Sorry, there is/are no recorded transaction/s for the date you selected.</span>                                                                                   
                        </div>
                        </Col>
                    </Row>
                    <Row style={{ marginTop:'20px'}}>
                        <Col>
                        <SubmitBtn style={{color:'#FFFFFF'}} onClick= {this.goBack}>Back</SubmitBtn>
                        </Col>

                    </Row>
                </Container>
                </ContentDiv>
        </div>                                  
    )
        
    }
    
}

ReportFileList.propTypes = propTypes;
ReportFileList.defaultProps = defaultProps;
export default ReportFileList;
